<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
          배너 관리
            <el-button class="title_btn" @click="addBannerData()" :disabled="btnState">배너등록
            </el-button>
        </div>
          <div class="mb10">
              PC 배너 이미지 1200 X 295 사이즈에 최적화 되어 있습니다.<br>
              Mobile 배너 이미지 710 X 384 사이즈에 최적화 되어 있습니다.<br>
              저장버튼을 눌러야 배너가 반영됩니다. <br>
              삭제시 해당 배너가 바로 삭제됩니다.
          </div>
        <div>
          <banner-list-component :bannerType="`list`"></banner-list-component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BannerListComponent from "@/components/banner/BannerListComponent";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
export default {
  name: "Banner",
  mixins: [],
  components: {
      BannerListComponent
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{
        btnState:false
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {
      EventBus.$on('topBannerAddBtn',this.checkBtnState)

  },
  beforeDestroy() {
      EventBus.$off('topBannerAddBtn',this.checkBtnState)
  },
  destroyed() {},
  computed: {
  },
  methods:{
      addBannerData(){
          EventBus.$emit('addBannerData')
      },
      checkBtnState(value){
          if(!value && !util.isArray(value)){
              return false
          }
          let length = value.filter(v => v.b_is_display === 1).length
          this.btnState = length > 9

      },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>
